<template>
  <div>
    <md-empty-state
      md-icon="settings"
      md-label="Administration"
      md-description="This is where you manage global settings.">
    </md-empty-state>
  </div>
</template>

<script>
    export default {
      name: 'admin-main'
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/Main.vue